import type { TrailResponse } from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type { TrailDetail, TrailSection, TrailSectionsGeoJSON, TrailResponse } from "@atlas/shared";

export function fetchTrail(id: string): Promise<TrailResponse> {
  return apiGet(`/trails/${id}`);
}
